export default function ContactCTA() {
  const submitAddr = 'https://readdy.ai/api/form/d75nomnlpdqvlupfphlg';

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as URLSearchParams);
    try {
      await fetch(submitAddr, { method: 'POST', body: data });
      form.reset();
      const btn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
      if (btn) {
        btn.textContent = 'Gönderildi! ✓';
        btn.disabled = true;
        setTimeout(() => {
          btn.textContent = 'Randevu Talep Et';
          btn.disabled = false;
        }, 3000);
      }
    } catch {
      // silent
    }
  };

  return (
    <section id="iletisim" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-[#D4AF37] text-xs font-semibold uppercase tracking-[0.3em] mb-3 block">İletişim</span>
          <h2 className="font-serif text-3xl md:text-4xl text-[#2D2D2D] mb-4">
            Hemen Bizimle
            <br />
            <em className="text-[#D4AF37]">İletişime Geçin</em>
          </h2>
          <p className="text-[#6B6B6B] text-sm max-w-md mx-auto">
            Ücretsiz ön görüşme için randevu alın, size en uygun tedaviyi birlikte belirleyelim
          </p>
          <div className="w-16 h-0.5 bg-[#D4AF37] mx-auto mt-4" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {/* Left - Contact Cards */}
          <div className="space-y-4">
            {/* WhatsApp - prominent */}
            <a
              href="https://wa.me/905412190629"
              target="_blank"
              rel="nofollow noreferrer"
              className="flex items-center gap-5 bg-[#25D366] text-white p-6 rounded-2xl hover:bg-[#1DA851] transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white/20 flex-shrink-0">
                <i className="ri-whatsapp-line text-white text-2xl"></i>
              </div>
              <div className="flex-1">
                <p className="font-bold text-lg">0541 219 06 29</p>
                <p className="text-white/85 text-sm">WhatsApp ile hızlı iletişim</p>
              </div>
              <i className="ri-arrow-right-line text-white/70 group-hover:translate-x-1 transition-transform"></i>
            </a>

            {/* Phone */}
            <a
              href="tel:02222347234"
              className="flex items-center gap-5 bg-[#FFF8F0] border-2 border-[#FFE5EC] text-[#2D2D2D] p-6 rounded-2xl hover:border-[#D4AF37]/40 transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gradient-to-br from-[#D4AF37]/20 to-[#FFB3C6]/20 flex-shrink-0">
                <i className="ri-phone-line text-[#D4AF37] text-2xl"></i>
              </div>
              <div className="flex-1">
                <p className="font-bold text-lg">0222 234 7 234</p>
                <p className="text-[#6B6B6B] text-sm">Sabit hat iletişim</p>
              </div>
              <i className="ri-arrow-right-line text-[#6B6B6B] group-hover:translate-x-1 transition-transform"></i>
            </a>

            {/* Phone 2 */}
            <a
              href="tel:05412190629"
              className="flex items-center gap-5 bg-[#FFF8F0] border-2 border-[#FFE5EC] text-[#2D2D2D] p-6 rounded-2xl hover:border-[#D4AF37]/40 transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gradient-to-br from-[#D4AF37]/20 to-[#FFB3C6]/20 flex-shrink-0">
                <i className="ri-smartphone-line text-[#D4AF37] text-2xl"></i>
              </div>
              <div className="flex-1">
                <p className="font-bold text-lg">0541 219 06 29</p>
                <p className="text-[#6B6B6B] text-sm">Cep telefonu</p>
              </div>
              <i className="ri-arrow-right-line text-[#6B6B6B] group-hover:translate-x-1 transition-transform"></i>
            </a>

            {/* Address */}
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=Hacı+Alibey+Mahallesi+Sakarya+1+Caddesi+Gürdal+Abacı+Plaza+No+50+Eskisehir+Turkey"
              target="_blank"
              rel="nofollow noreferrer"
              className="flex items-center gap-5 bg-[#FFF8F0] border-2 border-[#FFE5EC] text-[#2D2D2D] p-6 rounded-2xl hover:border-[#D4AF37]/40 transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gradient-to-br from-[#D4AF37]/20 to-[#FFB3C6]/20 flex-shrink-0">
                <i className="ri-map-pin-2-line text-[#D4AF37] text-2xl"></i>
              </div>
              <div className="flex-1">
                <p className="font-bold text-sm mb-0.5">Adresimiz</p>
                <p className="text-[#6B6B6B] text-xs leading-relaxed">
                  Hacı Alibey Mah. Sakarya 1. Cad.<br />
                  Gürdal Abacı Plaza No:50 Kat:3/8<br />
                  <span className="text-[#D4AF37] font-medium">Eskişehir</span>
                </p>
              </div>
              <div className="flex flex-col items-center gap-1 flex-shrink-0">
                <i className="ri-arrow-right-line text-[#6B6B6B] group-hover:translate-x-1 transition-transform"></i>
                <span className="text-[#D4AF37] text-xs font-medium whitespace-nowrap">Yol Tarifi</span>
              </div>
            </a>

            {/* Social media */}
            <div className="bg-[#FFF8F0] border border-[#FFE5EC] rounded-2xl p-6">
              <p className="text-[#2D2D2D] font-semibold text-sm mb-4">Sosyal Medya</p>
              <div className="flex items-center gap-3">
                {[
                  { icon: 'ri-instagram-line', label: 'Instagram', href: 'https://www.instagram.com/ayfercetinguzellik/' },
                  { icon: 'ri-facebook-line', label: 'Facebook', href: 'https://www.facebook.com/ayfercetinguzelliksalonu' },
                  { icon: 'ri-tiktok-line', label: 'TikTok', href: '#' },
                  { icon: 'ri-youtube-line', label: 'YouTube', href: '#' },
                ].map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    target={s.href !== '#' ? '_blank' : undefined}
                    rel="nofollow noreferrer"
                    title={s.label}
                    className="w-11 h-11 flex items-center justify-center rounded-full border-2 border-[#FFE5EC] bg-white hover:border-[#D4AF37] cursor-pointer transition-all duration-300 hover:-translate-y-1"
                  >
                    <i className={`${s.icon} text-[#6B6B6B] text-lg`}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Right - Quick Form */}
          <div className="bg-[#FFF8F0] rounded-3xl p-6 md:p-8 border border-[#FFE5EC]">
            <h3 className="font-serif text-[#2D2D2D] text-xl font-bold mb-2">Randevu Talep Formu</h3>
            <p className="text-[#6B6B6B] text-sm mb-6">Formu doldurun, en kısa sürede sizinle iletişime geçelim</p>
            <form data-readdy-form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-[#2D2D2D] text-xs font-semibold mb-1.5">Ad Soyad *</label>
                <input
                  type="text"
                  name="ad_soyad"
                  required
                  placeholder="Adınızı girin"
                  className="w-full border border-[#FFE5EC] rounded-xl px-4 py-3 text-sm text-[#2D2D2D] bg-white focus:outline-none focus:border-[#D4AF37] transition-colors"
                />
              </div>
              <div>
                <label className="block text-[#2D2D2D] text-xs font-semibold mb-1.5">Telefon *</label>
                <input
                  type="tel"
                  name="telefon"
                  required
                  placeholder="05XX XXX XX XX"
                  className="w-full border border-[#FFE5EC] rounded-xl px-4 py-3 text-sm text-[#2D2D2D] bg-white focus:outline-none focus:border-[#D4AF37] transition-colors"
                />
              </div>
              <div>
                <label className="block text-[#2D2D2D] text-xs font-semibold mb-1.5">E-posta</label>
                <input
                  type="email"
                  name="email"
                  placeholder="ornek@email.com"
                  className="w-full border border-[#FFE5EC] rounded-xl px-4 py-3 text-sm text-[#2D2D2D] bg-white focus:outline-none focus:border-[#D4AF37] transition-colors"
                />
              </div>
              <div>
                <label className="block text-[#2D2D2D] text-xs font-semibold mb-1.5">İlgilendiğiniz Hizmet</label>
                <select
                  name="hizmet"
                  className="w-full border border-[#FFE5EC] rounded-xl px-4 py-3 text-sm text-[#2D2D2D] bg-white focus:outline-none focus:border-[#D4AF37] transition-colors cursor-pointer"
                >
                  <option value="">Seçiniz...</option>
                  <option value="EMS Slim">EMS Slim</option>
                  <option value="ARC Cilt Yenileme">ARC Cilt Yenileme</option>
                  <option value="Lazer Epilasyon">Lazer Epilasyon</option>
                  <option value="İğneli Epilasyon">İğneli Epilasyon</option>
                  <option value="Kalıcı Makyaj">Kalıcı Makyaj</option>
                  <option value="Cilt Bakımı">Cilt Bakımı</option>
                  <option value="Mezoterapi">Mezoterapi</option>
                  <option value="Ameliyatsız Yüz Germe">Ameliyatsız Yüz Germe</option>
                  <option value="Diğer">Diğer</option>
                </select>
              </div>
              <div>
                <label className="block text-[#2D2D2D] text-xs font-semibold mb-1.5">Mesajınız</label>
                <textarea
                  name="mesaj"
                  rows={3}
                  maxLength={500}
                  placeholder="Randevu talebinizi veya sorularınızı yazın..."
                  className="w-full border border-[#FFE5EC] rounded-xl px-4 py-3 text-sm text-[#2D2D2D] bg-white focus:outline-none focus:border-[#D4AF37] transition-colors resize-none"
                />
              </div>
              <button
                type="submit"
                className="w-full bg-[#D4AF37] text-white py-3.5 rounded-full font-semibold text-sm hover:bg-[#B8962E] transition-colors whitespace-nowrap"
              >
                Randevu Talep Et
              </button>
            </form>
          </div>
        </div>

        {/* Google Maps */}
        <div className="mt-12">
          <div className="flex items-center justify-between mb-5">
            <div>
              <h3 className="font-serif text-[#2D2D2D] text-xl font-bold">Bizi Haritada Bulun</h3>
              <p className="text-[#6B6B6B] text-sm mt-1">
                <i className="ri-map-pin-2-line text-[#D4AF37]"></i>
                {' '}Hacı Alibey Mah. Sakarya 1. Cad. Gürdal Abacı Plaza No:50 Kat:3/8, Eskişehir
              </p>
            </div>
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=Hacı+Alibey+Mahallesi+Sakarya+1+Caddesi+Gürdal+Abacı+Plaza+No+50+Eskisehir+Turkey"
              target="_blank"
              rel="nofollow noreferrer"
              className="hidden sm:flex items-center gap-2 bg-[#D4AF37] text-white px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-[#B8962E] transition-all hover:-translate-y-0.5 whitespace-nowrap"
            >
              <i className="ri-navigation-line"></i>
              Yol Tarifi Al
            </a>
          </div>
          <div className="rounded-2xl overflow-hidden border border-[#FFE5EC]" style={{ height: '360px' }}>
            <iframe
              title="Ayfer Çetin Güzellik Salonu Konum"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              src="https://maps.google.com/maps?q=Hacı+Alibey+Mahallesi+Sakarya+1+Caddesi+Gürdal+Abacı+Plaza+No:50+Eskisehir+Turkey&output=embed&z=16"
            />
          </div>
          <div className="mt-4 sm:hidden">
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=Hacı+Alibey+Mahallesi+Sakarya+1+Caddesi+Gürdal+Abacı+Plaza+No+50+Eskisehir+Turkey"
              target="_blank"
              rel="nofollow noreferrer"
              className="flex items-center justify-center gap-2 bg-[#D4AF37] text-white px-5 py-3 rounded-full text-sm font-semibold whitespace-nowrap"
            >
              <i className="ri-navigation-line"></i>
              Yol Tarifi Al
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
